import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import NumberFormat from "react-number-format";
import { Row, Typography } from "antd";
import { Spin } from "antd";
import cubejsApi from "../../../cubejsApiBQ";

const { Title } = Typography;
var color;
var valor;

const percentRender = ({ resultSet, props }) => {
    const name = [
        "BaseResumenColocacion.porcentajeNegado",
        "BaseResumenColocacion.porcentajeEnEstudio",
        "BaseResumenColocacion.porcentajeAprobado",
        "BaseResumenColocacion.porcentajeDesembolsado",
    ];
    valor = resultSet.loadResponse.data[0][name[props.index]];
    if (valor === null) {
        valor = "-";
        color = "#769995";
    } else if (valor < 0) {
        if (props.index === 0) {
            color = "#30B359";
        } else {
            color = "#FF615E";
        }
    } else if (valor > 0) {
        if (props.index === 0) {
            color = "#FF615E";
        } else {
            color = "#30B359";
        }
    } else color = "#769995";
    return (
        <Row gutter={[0, 0]} type="flex" justify="center">
            <Title
                style={{
                    fontSize: "14px",
                    color: color,
                }}
            >
                <NumberFormat
                    value={valor}
                    decimalScale={1}
                    displayType={"text"}
                    thousandSeparator={true}
                    suffix={"%"}
                />
            </Title>
        </Row>
    );
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const PercentRender = (props) => {
    return (
        <QueryRenderer
            query={{
                renewQuery: true,
                measures: [
                    // "BaseResumenColocacion.porcentajeNegado",
                    // "BaseResumenColocacion.porcentajeEnEstudio",
                    // "BaseResumenColocacion.porcentajeAprobado",
                    "BaseResumenColocacion.porcentajeDesembolsado",
                ],
                timeDimensions: [],
                dimensions: [],
                segments: [],
                filters: [
                    {
                        dimension: "BaseResumenColocacion.fechaCorte",
                        operator: "contains",
                        values: props.fecha !== "" ? [props.fecha] : [],
                    },
                    {
                        dimension: "Usuarios.idCedula",
                        operator: "contains",
                        values: props.cedula !== "" ? [props.cedula] : [],
                    },
                    {
                        dimension: "BaseResumenColocacion.zona",
                        operator: "contains",
                        values: props.zona !== "" ? [props.zona] : [],
                    },
                ],
            }}
            cubejsApi={cubejsApi}
            render={renderChart(percentRender, props)}
        />
    );
};

export default PercentRender;
